<template>
    <b-form-group
        :label-for="id"
        :label="label"
        :invalid-feedback="invalidFeedback"
        :valid-feedback="validFeedback"
        :state="state"
    >
        <b-form-input
            :id="id"
            :value="value"
            @input="onInput"
            type="email"
            :placeholder="placeholder"
            :state="state"
            trim
        ></b-form-input>
    </b-form-group>
</template>

<script>
    import debounce from 'lodash/debounce';

    const EMAIL_RE = /\S+@\S+\.\S+/;
    let count = 0;

    export default {
        name: 'FormGroupEmail',
        props: {
            value: {
                type: String,
                default: '',
            },
            id: {
                type: String,
                default: function() {
                    count++;
                    return `email${count}`;
                },
            },
            label: {
                type: String,
                default: 'E-mail address',
            },
            placeholder: {
                type: String,
                default: 'E-mail address',
            },
            invalidFeedback: {
                type: String,
                default: 'Please enter a valid e-mail address',
            },
            validFeedback: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                state: false,
            };
        },
        methods: {
            onInput: debounce(function(newValue) {
                const isValid = EMAIL_RE.test(newValue);
                if (this.state !== isValid) {
                    this.state = isValid;
                }
                if (isValid) {
                    this.$emit('input', newValue);
                }
            }, 500),
        },
        mounted() {
            this.state = EMAIL_RE.test(this.value);
        },
        watch: {
            value: function(newValue) {
                const isValid = EMAIL_RE.test(newValue);
                if (this.state !== isValid) {
                    this.state = isValid;
                }
            },
        },
    };
</script>
